import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
    images?: string[];
}

export const UserChatMessage = ({ message, images }: Props) => {
    return (
        <div className={styles.container}>
            <div className={styles.message}>
                {images && images.length > 0 && (
                    <div className={styles.imageRow}>
                        {images.map((src, i) => (
                            <img key={i} src={src} alt={`Uploaded ${i + 1}`} className={styles.thumbnail} />
                        ))}
                    </div>
                )}
                {message}
            </div>
        </div>
    );
};
